import { useState } from "react";
import { Alert, Button, FormGroup, Input, Label } from "reactstrap";
import { unwrapPayload, formatDate } from "../../utilities";

export function WorkerHistorySection
(
    {
        searchWorkerHistory
    }
    :
    {
        searchWorkerHistory: (values: any) => Promise<any>;
    }
)
{
    const [limit, setLimit] = useState(50);
    const [eventType, setEventType] = useState('');
    const [status, setStatus] = useState('');
    const [result, setResult] = useState<any | null>(null);
    const [error, setError] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState(false);

    const loadHistory = async () =>
    {
        setError(null);
        setIsLoading(true);

        try
        {
            const response = await searchWorkerHistory({
                limit,
                eventTypes: eventType ? [eventType] : [],
                statuses: status ? [status] : []
            });

            setResult(unwrapPayload(response));
        }
        catch (exception: any)
        {
            setError(exception?.message ?? 'Pobieranie historii workera zakończyło się błędem.');
        }
        finally
        {
            setIsLoading(false);
        }
    };

    const items = result?.items || [];

    return (
        <section className="mt-5">
            <h5>Historia eksportu</h5>

            {error && <Alert color="danger">{error}</Alert>}

            <div className="row">
                <div className="col-12 col-xl-3">
                    <FormGroup>
                        <Label>Limit</Label>
                        <Input
                            type="number"
                            min={1}
                            max={500}
                            value={limit}
                            onChange={event => setLimit(Number.parseInt(event.target.value, 10) || 50)}
                        />
                    </FormGroup>
                </div>

                <div className="col-12 col-xl-3">
                    <FormGroup>
                        <Label>Typ zdarzenia</Label>
                        <Input
                            type="select"
                            value={eventType}
                            onChange={event => setEventType(event.target.value)}
                        >
                            <option value="">Wszystkie</option>
                            <option value="NoWork">NoWork</option>
                            <option value="RunSummary">RunSummary</option>
                            <option value="Error">Error</option>
                        </Input>
                    </FormGroup>
                </div>

                <div className="col-12 col-xl-3">
                    <FormGroup>
                        <Label>Status</Label>
                        <Input
                            type="select"
                            value={status}
                            onChange={event => setStatus(event.target.value)}
                        >
                            <option value="">Wszystkie</option>
                            <option value="Success">Success</option>
                            <option value="Warning">Warning</option>
                            <option value="Failed">Failed</option>
                        </Input>
                    </FormGroup>
                </div>

                <div className="col-12 col-xl-3 d-flex align-items-end justify-content-xl-end">
                    <Button
                        type="button"
                        color="secondary"
                        className="mb-3"
                        disabled={isLoading}
                        onClick={loadHistory}
                    >
                        Pokaż historię
                    </Button>
                </div>
            </div>

            {result && (
                <div className="mt-3">
                    {result.message && (
                        <Alert color={result.success === false ? 'warning' : 'success'}>
                            {result.message}
                        </Alert>
                    )}

                    {items.length === 0 ? (
                        <Alert color="info">
                            Brak wpisów historii eksportu.
                        </Alert>
                    ) : (
                        <div className="table-responsive">
                            <table className="table table-sm table-bordered mb-0">
                                <thead>
                                    <tr>
                                        <th>Ostatnio</th>
                                        <th>Od</th>
                                        <th>Typ</th>
                                        <th>Status</th>
                                        <th>Klucz</th>
                                        <th>Wystąpienia</th>
                                        <th>Prepared</th>
                                        <th>Sent</th>
                                        <th>Skipped</th>
                                        <th>Failed</th>
                                        <th>Komunikat</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {items.map((item: any) => (
                                        <tr key={item.id}>
                                            <td>{formatDate(item.lastAt)}</td>
                                            <td>{formatDate(item.firstAt)}</td>
                                            <td>{item.eventType}</td>
                                            <td>{item.status}</td>
                                            <td><code>{item.aggregationKey}</code></td>
                                            <td>{item.occurrenceCount}</td>
                                            <td>{item.preparedCount}</td>
                                            <td>{item.sentCount}</td>
                                            <td>{item.skippedCount}</td>
                                            <td>{item.failedCount}</td>
                                            <td>{item.message}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}

                    <details className="mt-4">
                        <summary>Raw JSON</summary>
                        <pre className="mt-3">{JSON.stringify(result, null, 2)}</pre>
                    </details>
                </div>
            )}
        </section>
    );
}